export default __webpack_public_path__ + "static/media/payment.fa627833.jpg";